import { render, staticRenderFns } from "./PhraseList.vue?vue&type=template&id=2cb61db9"
import script from "./PhraseList.vue?vue&type=script&lang=js"
export * from "./PhraseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports